export default __webpack_public_path__ + "static/media/KURNIAWAN.7eb69dd8.png";